<svg
  width="17"
  height="20"
  viewBox="0 0 17 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Frame 1">
    <g id="Logo">
      <path
        id="XMLID_34_"
        d="M10.8815 3.36828C10.1836 4.18909 9.06681 4.83648 7.95006 4.744C7.81046 3.63418 8.35721 2.45499 8.99701 1.72667C9.69499 0.882747 10.9164 0.281594 11.9052 0.235352C12.0216 1.39141 11.5679 2.52436 10.8815 3.36828ZM11.8936 4.96365C10.2766 4.87117 8.89232 5.87694 8.12455 5.87694C7.34515 5.87694 6.17023 5.00989 4.89061 5.03301C3.22711 5.05614 1.67994 5.99255 0.830743 7.48387C-0.914187 10.4665 0.377061 14.8827 2.06383 17.3104C2.88976 18.5127 3.87855 19.8306 5.18143 19.7844C6.41452 19.7381 6.9031 18.9867 8.3921 18.9867C9.89274 18.9867 10.3232 19.7844 11.626 19.7613C12.9755 19.7381 13.8247 18.559 14.6506 17.3567C15.5928 15.9925 15.9767 14.663 16 14.5937C15.9767 14.5705 13.3942 13.5879 13.371 10.6284C13.3477 8.15439 15.4067 6.9752 15.4998 6.90584C14.3365 5.19486 12.5218 5.00989 11.8936 4.96365Z"
        fill="black"
      />
    </g>
  </g>
</svg>
